import * as React from "react";
import { HoverableImage } from "../../components/HoverableImage/HoverableImage";
import { theShapeOfFlightPhotos } from "../../constants/photos";
import styles from "./TheShapeOfFlight.module.css";

const TheShapeOfFlight = () => {
  const gallery = theShapeOfFlightPhotos.map((image) => (
    <HoverableImage
      src={image.src}
      infoTitle={image.infoTitle}
      infoDescription={image.infoDescription}
      isHalfImg={image.isHalfImg}
    />
  ));

  return (
    <>
      <h2 className={styles.title}>The Shape Of Flight</h2>
      <p className={styles.description}>
        The Shape of Flight explores flight in its most essential state. Inspired by Constantin Brâncuși’s pursuit of pure form, it avoids literal references to wings, feathers or birds and instead searches for the élan of flight: the dynamic force contained in the moment before movement begins. Flight is understood not as escape, but as detachment - <i>I detach, I rise above</i>. To suppress the shape is to prepare its flight.
        <br></br>
        Developed through large-scale vertical draping, engineered metal circles, articulated structures, sculpted foam and jersey, the work allows weight, resistance and elasticity to direct the form. Presented as the installation <i>Body Absent / Body Present</i>, the garments remain sculpturally active without the body and transform through movement when inhabited. Rooted in Romanian culture, the project uses flight and verticality to move beyond folklorised representations of heritage and express the desire to rise above constraint.
        </p>
      <div className={styles.galleryContainer}>
        <div className={styles.desktopGalleryContainer}>{gallery}</div>
        <div className={styles.mobileGalleryContainer}>{gallery}</div>
      </div>
      <p className={styles.description}>
        Photography: Shawn James (catwalk) and Roxana Georgesu (other)
      </p>
      <p className={styles.description}>
        Models & Make-up: Maria Neagu & Teodora Gheorghe
      </p>
      <p className={styles.description}>
        Creative direction & Designs: Flavia Nistor
      </p>
    </>
  );
};

export default TheShapeOfFlight;
